import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { ExclamationMark } from '../ExclamationMark';

interface Props {
	title: string;
	message: string;
}

export const NoteBox: FC<Props> = ({ title, message }) => {
	return (
		<Stack
			sx={{
				backgroundColor: '#FFF8DF',
				borderRadius: '4px',
				padding: '8px 16px 8px 16px',
				gap: '4px',
			}}>
			<Stack direction={'row'} alignItems={'center'} gap={'4px'} justifyContent={'start'}>
				<ExclamationMark />
				<Typography variant={'mediumToLargeBold'}>{title}</Typography>
			</Stack>
			<Typography variant={'mediumToLargeRegular'}>{message}</Typography>
		</Stack>
	);
};
